import React, { useCallback, useState } from 'react';
import { compose, find, prop, propEq } from 'ramda';
import { branch, renderComponent, withProps } from 'recompose';
import { useDeviceSelector } from 'js/store/hooks';
import { CategoryContext } from '../context';
import Tabs from './Tabs';
import Category from './Category';
import Title from './CategoryTitle';
import style from './index.scss';

export const GamesCategory = ({ status, id, title, games, expandedCategory, setExpandedCategory }) => (
    <CategoryContext.Provider value={{ status, expandedCategory, setExpandedCategory }}>
        <Category
            cid={id}
            title={title}
            gameCodes={games}
            className={style.category}
        />
    </CategoryContext.Provider>
);

export const GamesForMobile = ({ rules, activeTab, tabClick, id, className = '', ...rest }) => (
    <div className={`${className} ${style.container}`}>
        <Tabs onChange={tabClick} activeTab={activeTab} tabs={rules} />
        <GamesCategory key={id} {...{ id, ...rest }} />
    </div>
);

export const GamesForDesktop = ({ rules, className = '' }) => {
    const [expandedCategory, setExpandedCategory] = useState(null);

    return (
        <div className={`${className} ${style.container}`}>
            {rules.map((rule) => {
                const { status, endDateTime: endTime, startDateTime: startTime, games, id } = rule;
                const title = <Title {...{ status, endTime, startTime }} />;

                return <GamesCategory
                    key={id}
                    id={id}
                    status={status}
                    title={title}
                    games={games}
                    expandedCategory={expandedCategory}
                    setExpandedCategory={setExpandedCategory}
                />;
            })}
        </div>
    );
};

export default compose(
    branch(
        () => useDeviceSelector(prop('isDesktop')),
        renderComponent(GamesForDesktop)
    ),
    withProps(
        ({ rules }) => {
            const [activeTab, setActiveTab] = useState(rules[0].id);
            const getRule = useCallback(id => find(propEq('id', id), rules), [rules]);
            const tabClick = useCallback((id) => {
                setActiveTab(id);
            }, [setActiveTab]);
            const { id, games, status } = getRule(activeTab);

            return {
                id,
                games,
                status,
                activeTab,
                tabClick,
                rules
            };
        }
    )
)(GamesForMobile);
